import { Breakpoints, Container, ContainerPadding, CTA } from '@volkswagen-onehub/components-core';
import { Close } from '@volkswagen-onehub/icons-core';
import React from 'react';
import { PortalContext } from '../../../../../context/portal-context';
import { HuchaValues } from '../../models/hucha-values';
import { HuchaStandardVouchersPopup } from './popup-hucha-standard';
import { Renovador10To15VouchersPopup } from './popup-hucha-renovadores-10-to-15';
import { RenovadorPlus15VouchersPopup } from './popup-hucha-renovadores-plus15';

export const HuchaPopupContent = ({
	huchaValues,
	portalContext,
	handlePopupClose,
}: {
	huchaValues: HuchaValues | null;
	portalContext: any;
	handlePopupClose: () => void;
}) => {
	const layerContent = () => {
		if (huchaValues?.huchaTier === 'standard') {
			return <HuchaStandardVouchersPopup huchaValues={huchaValues} />;
		}

		if (huchaValues?.huchaTier === 'renovador10To15') {
			return <Renovador10To15VouchersPopup huchaValues={huchaValues} />;
		}

		if (huchaValues?.huchaTier === 'renovadorPlus15') {
			return <RenovadorPlus15VouchersPopup huchaValues={huchaValues} />;
		}
		return null;
	};

	return (
		<PortalContext.Provider value={portalContext}>
			<Container
				horizontalAlign={'flex-end'}
				padding={{
					top: ContainerPadding.dynamic0100,
					right: {
						[Breakpoints.default]: ContainerPadding.grid001,
						[Breakpoints.b1600]: ContainerPadding.dynamic0100,
					},
					bottom: ContainerPadding.dynamic0100,
				}}
			>
				<CTA
					tag="button"
					emphasis="tertiary"
					onClick={handlePopupClose}
					aria-label="Close pop-up"
					icon={<Close variant="default" aria-hidden />}
				/>
			</Container>
			{layerContent()}
		</PortalContext.Provider>
	);
};
